export enum Role {
	USER = 'user',
	ASSISTANT = 'assistant',
}
